export default "__VITE_ASSET__0HG2viY4__"